import {
    AddDevelopmentPlanSkillFormData,
    AddDevelopmentPlanSkillRequest,
    DevelopmentPlanCnlSkillResource,
    DevelopmentPlanSkill,
    EditDevelopmentPlanSkillFormData,
    EditDevelopmentPlanSkillRequest,
} from './DevelopmentPlanSkill';

export const transformToDevelopmentPlanSkill = (resource: DevelopmentPlanCnlSkillResource): DevelopmentPlanSkill => ({
    id: resource.id,
    name: resource.name,
    remarks: resource.remarks || '',
    skillId: resource.cnlSkillId,
    isCompleted: resource.isCompleted,
});

export const transformToAddDevelopmentPlanSkillRequest = (formData: AddDevelopmentPlanSkillFormData): AddDevelopmentPlanSkillRequest => ({
    name: formData.name,
    cnlSkillId: formData.skillId,
    developmentPlanId: formData.developmentPlanId,
});

export const transformToEditDevelopmentPlanSkillRequest = (formData: EditDevelopmentPlanSkillFormData): EditDevelopmentPlanSkillRequest => ({
    remarks: formData.remarks,
    isCompleted: formData.isCompleted,
});
